import { render, staticRenderFns } from "./chat_customer.vue?vue&type=template&id=cc1a0dd2&scoped=true&"
import script from "./chat_customer.vue?vue&type=script&lang=js&"
export * from "./chat_customer.vue?vue&type=script&lang=js&"
import style0 from "./chat_customer.vue?vue&type=style&index=0&id=cc1a0dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a0dd2",
  null
  
)

export default component.exports